module.exports = __webpack_public_path__ + "media/styles/images/png/slash-gray-25fb5bcee75646826a25cd374b5731e1.png";